<template>
  <div :id="appName" :class="[appName, appCode]">
    <OnboardingModal
      v-if="firstTimeUser"
      :popupVisible="firstTimeUser"
      :menuItems="onboardingMenuItems"
      @close="setFirstVisitedData"></OnboardingModal>
    <div class="header-wrapper">
      <nav class="navigation-bar">
        <router-link class="nav-link" :to="`/${appCode}/get-started`">
          Get Started
        </router-link>
        <router-link :class="['nav-link', { 'router-link-active router-link-exact-active': isAdditionalActive }]" :to="`/${appCode}/workflows`">
          Workflows
        </router-link>
        <router-link class="nav-link" :to="`/${appCode}/partners`">
          Integrations
        </router-link>
        <router-link v-if="isWidgetsTabEnabled" class="nav-link" :to="`/${appCode}/widgets`">
          Widgets
        </router-link>
      </nav>
    </div>
    <div class="content-wrapper">
      <router-view :name="appCode"></router-view>
    </div>
  </div>
</template>

<script>
import { includes } from 'lodash';
import { Vuex } from 'vue-infra';
import { appCode, appName } from '../config';
// import OnboardingModal from './components/onboardingModal/onboarding-modal';
import { GETTER_TYPES as SHELL_GETTER_TYPES } from './store/modules/shell/getters';
import { ACTION_TYPES as SHELL_ACTION_TYPES } from './store/modules/shell/actions';
import { FEATURE_FLAGS } from './common/consts';

const mapActions = Vuex.mapActions;
const mapGetters = Vuex.mapGetters;
export default {
  name: appCode,
  components: {
    // OnboardingModal,
  },
  data() {
    return {
      module: '',
      appName,
      appCode,
      path: '',
      isWidgetsEnabled: false,
    };
  },
  computed: {
    ...mapGetters('lp-le-ihub/shell', {
      firstTimeUser: SHELL_GETTER_TYPES.GET_FIRST_TIME_USER,
      onboardingMenuItems: SHELL_GETTER_TYPES.GET_ONBOARDING_ITEMS,
      getStartedItems: SHELL_GETTER_TYPES.GET_ITEMS,
      getFeatureFlag: SHELL_GETTER_TYPES.GET_FEATURE_FLAG,
    }),
    routeName() {
      return this.$route.name;
    },
    isWidgetsTabEnabled() {
      return this.getFeatureFlag(FEATURE_FLAGS.SHOW_WIDGETS_TAB);
    },
    isAdditionalActive() {
      return ['workato-activation', 'workato-nonadmin', 'workato-integration'].includes(this.$route.name);
    },
  },
  updated() {
    this.getModule();
  },
  async mounted() {
    this.fetchFeatureFlags();
    if (window.Workato) {
      window.Workato.configure({
        embeddingUrlPrefix: '/ihu/integration',
      });
    }
    this.getModule();
    if (!includes(window.document.body.className, 'theme-')) {
      window.document.body.className = 'theme-dark';
    }
    this.fetchShellInfo();
  },
  methods: {
    ...mapActions('lp-le-ihub/shell', {
      fetchShellInfo: SHELL_ACTION_TYPES.FETCH_SHELL_ITEMS,
      setFirstVisitedData: SHELL_ACTION_TYPES.SET_FIRST_TIME_VISITED,
      fetchFeatureFlags: SHELL_ACTION_TYPES.FETCH_FEATURE_FLAGS,
    }),
    getModule() {
      this.module = this.$router.currentRoute.path?.substr(5) || this.$router.currentRoute.value.path.substr(5);
    },
  },
};
</script>

<style lang="scss">
  .lp-le-ihub.ihu {
    font-family: $font-family-Roboto;
    height: 100%;
    text-align: center;
    background-position: center;
    background-image: none;
    @include themify {
      color: getColor('text');
      background-color: getColor('main-ihub-background', 'ihu');
    }
    .header-wrapper {
      padding-left: .75rem;
      justify-content: flex-start;
      display: flex;
      @include themify ('light'){
        background: getColor('main-ihub-background', 'ihu');
      };
      .navigation-bar {
        display: flex;
        font-size: 15px;
        line-height: 133%;
        letter-spacing: 0.02em;
        font-weight: 500;
        .nav-link {
          text-decoration: none;
          opacity: .7;
          margin: .3rem 1rem 0;
          padding: .5rem 0;
          @include themify {
            color: getColor('navbar-link-color', 'ihu');
          }
          &.router-link-exact-active {
            opacity: 0.9;
          }
          &.router-link-active {
            border-bottom: 2px solid;
            @include themify {
              border-color: getColor('navbar-active-link-border', 'ihu');
              color: getColor('navigation-bar-text-color-active', 'ihu');
            }
          }
        }
      }
    }
    h1 {
      margin: 1rem 0;
      font-size: 2rem;
    }
    .content-wrapper {
      height: 100%;
      @include themify ('light'){
        background: getColor('main-ihub-background', 'ihu');
      };
    }
  }
</style>
